import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CreatorWaiver from 'components/pages/CreatorWaiver';

function mapStateToProps(state, ownProps) {
  return {
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      signupActions: bindActionCreators(require('actions/signupActions'), dispatch),
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatorWaiver);


// WEBPACK FOOTER //
// ./src/containers/CreatorWaiverContainer.js